// MyPreGameTopAndBottomCard
import React from "react";
import Card from "react-bootstrap/Card";
import {Col, Row} from "react-bootstrap";

const MyPreGameTopAndBottomCard = (props) => {
    const {
        isMobile,
        groupPosition,
    } = props;

    // console.log("groupPosition >>>>", groupPosition)

    const groupBackgroundColors = {
        "Group A": "bg-group-a",
        "Group B": "bg-group-b",
        "Group C": "bg-group-c",
        "Group D": "bg-group-d",
        "Group E": "bg-group-e",
        "Group F": "bg-group-f"
    };


    const renderMobile = () => {
        return (
            <>
                <Card className={"bg-white rounded-4 border-0 d-flex align-items-center"}>
                    <Card.Header
                        className={`d-flex w-100 justify-content-center align-items-center border-0 p-0 m-0 bg-transparent`}
                    >
                        <div
                            className={`text-uppercase w-50 rounded-bottom-4 border-top-0 fw-400 font-15 text-white p-1 text-center ${
                                groupBackgroundColors[groupPosition?.name] || "bg-skins-red"
                            }`}
                        >
                            {groupPosition?.name}
                        </div>
                    </Card.Header>
                    <Card.Body className={`w-100 d-flex flex-column gap-2`}>
                        <Row >
                            <Col xs={5}></Col>
                            <Col xs={7} className={"d-flex align-items-center justify-content-between cabin fw-400 font-11"}>
                                <div>P</div>
                                <div>W</div>
                                <div>D</div>
                                <div>L</div>
                                <div>GD</div>
                                <div>Pts</div>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={5}>
                                <div className={"d-flex align-items-center gap-2"}>
                                    <div className={"cabin fw-bold font-11 "} style={{paddingRight: "4px"}}>1st</div>
                                    <img
                                        src={groupPosition?.first_position_team?.icon}
                                        className="team-card-image"
                                        alt={groupPosition?.first_position_team?.name || "..."}/>
                                    <div className={"cabin fw-400 font-11 text-uppercase"}>{groupPosition?.first_position_team?.name}</div>
                                </div>
                            </Col>
                            <Col xs={7} className={"d-flex align-items-center justify-content-between cabin fw-400 font-11"}>
                                <div>{groupPosition?.first_position_team?.standing?.played}</div>
                                <div>{groupPosition?.first_position_team?.standing?.win}</div>
                                <div>{groupPosition?.first_position_team?.standing?.draw}</div>
                                <div>{groupPosition?.first_position_team?.standing?.lose}</div>
                                <div>{groupPosition?.first_position_team?.standing?.goal_difference}</div>
                                <div>{groupPosition?.first_position_team?.standing?.points}</div>

                            </Col>
                        </Row>
                        <Row className={"mt-2"}>
                            <Col xs={5}>
                                <div className={"d-flex align-items-center gap-2"}>
                                    <div className={"cabin fw-bold font-11"}>4th</div>
                                    <img
                                        src={groupPosition?.last_position_team?.icon}
                                        className="team-card-image"
                                        alt={groupPosition?.last_position_team?.name || "..."}/>
                                    <div className={"cabin fw-400 font-11 text-uppercase"}>{groupPosition?.last_position_team?.name}</div>
                                </div>
                            </Col>
                            <Col xs={7} className={"d-flex align-items-center justify-content-between cabin fw-400 font-11"}>
                                <div>{groupPosition?.last_position_team?.standing?.played}</div>
                                <div>{groupPosition?.last_position_team?.standing?.win}</div>
                                <div>{groupPosition?.last_position_team?.standing?.draw}</div>
                                <div>{groupPosition?.last_position_team?.standing?.lose}</div>
                                <div>{groupPosition?.last_position_team?.standing?.goal_difference}</div>
                                <div>{groupPosition?.last_position_team?.standing?.points}</div>

                            </Col>
                        </Row>
                    </Card.Body>
                    <Card.Footer
                        className={'border-0 p-0 m-0 bg-transparent border-bottom-colors d-flex align-items-center rounded-0 w-75 d-flex align-items-center justify-content-center'}>

                    </Card.Footer>
                </Card>
            </>
        );
    }

    const renderDesktop = () => {
        return (
            <>
                <Card className={"bg-white rounded-4 border-0 d-flex align-items-center"}>
                    <Card.Header
                        className={`d-flex w-100 justify-content-center align-items-center border-0 p-0 m-0 bg-transparent`}
                    >
                        <div
                            className={`text-uppercase w-50 rounded-bottom-4 border-top-0 fw-400 font-15 text-white p-1 text-center ${
                                groupBackgroundColors[groupPosition?.name] || "bg-skins-red"
                            }`}
                        >
                            {groupPosition?.name}
                        </div>
                    </Card.Header>
                    <Card.Body className={`w-100 px-5 d-flex flex-column gap-2`}>
                        <Row >
                            <Col sm={5}></Col>
                            <Col sm={7} className={"d-flex align-items-center justify-content-between cabin fw-400 font-11"}>
                                <div>P</div>
                                <div>W</div>
                                <div>D</div>
                                <div>L</div>
                                <div>GD</div>
                                <div>Pts</div>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={5}>
                                <div className={"d-flex align-items-center gap-2"}>
                                    <div className={"cabin fw-bold font-15"} style={{paddingRight: "5px"}}>1st</div>
                                    <img
                                        src={groupPosition?.first_position_team?.icon}
                                        className="team-card-image"
                                        alt={groupPosition?.first_position_team?.name || "..."}/>
                                    <div className={"cabin fw-400 font-14 text-uppercase"}>{groupPosition?.first_position_team?.name}</div>
                                </div>
                            </Col>
                            <Col sm={7} className={"d-flex align-items-center justify-content-between cabin fw-400 font-11"}>
                                <div>{groupPosition?.first_position_team?.standing?.played}</div>
                                <div>{groupPosition?.first_position_team?.standing?.win}</div>
                                <div>{groupPosition?.first_position_team?.standing?.draw}</div>
                                <div>{groupPosition?.first_position_team?.standing?.lose}</div>
                                <div>{groupPosition?.first_position_team?.standing?.goal_difference}</div>
                                <div>{groupPosition?.first_position_team?.standing?.points}</div>

                            </Col>
                        </Row>
                        <Row className={"mt-2"}>
                            <Col sm={5}>
                                <div className={"d-flex align-items-center gap-2"}>
                                    <div className={"cabin fw-bold font-15"}>4th</div>
                                    <img
                                        src={groupPosition?.last_position_team?.icon}
                                        className="team-card-image"
                                        alt={groupPosition?.last_position_team?.name || "..."}/>
                                    <div className={"cabin fw-400 font-14 text-uppercase"}>{groupPosition?.last_position_team?.name}</div>
                                </div>
                            </Col>
                            <Col sm={7} className={"d-flex align-items-center justify-content-between cabin fw-400 font-11"}>
                                <div>{groupPosition?.last_position_team?.standing?.played}</div>
                                <div>{groupPosition?.last_position_team?.standing?.win}</div>
                                <div>{groupPosition?.last_position_team?.standing?.draw}</div>
                                <div>{groupPosition?.last_position_team?.standing?.lose}</div>
                                <div>{groupPosition?.last_position_team?.standing?.goal_difference}</div>
                                <div>{groupPosition?.last_position_team?.standing?.points}</div>

                            </Col>
                        </Row>
                    </Card.Body>
                    <Card.Footer
                        className={'border-0 p-0 m-0 bg-transparent border-bottom-colors d-flex align-items-center rounded-0 w-75 d-flex align-items-center justify-content-center'}>

                    </Card.Footer>
                </Card>
            </>
        );
    }
    const render = () => {
        return (
            <section>
                {isMobile ? renderMobile() : renderDesktop()}
            </section>
        );
    }

    return render();
}

export default MyPreGameTopAndBottomCard;
